import React, { Component } from "react";

import { aggregateStats } from "../../lib/stats/utils";
import StatsPageTable from "./stats_page_table";
import { countryCodesMap } from "../../../data/countries";

const columnInfo = [
  {
    accessor: "country",
    Header: "Country",
  },
  {
    id: "count",
    accessor: "count",
    Header: "Downloads",
    Cell: ({ row }) => (row.count || 0).toLocaleString(),
  },
];
class StatsCountryTable extends Component {
  render() {
    return (
      <div className="stats-table">
        <h3>Downloads By Country</h3>
        <StatsPageTable
          data={this.getData()}
          columns={columnInfo}
          defaultSorted={[
            {
              id: "count",
              desc: true,
            },
          ]}
        />
      </div>
    );
  }

  getData = () => {
    var data = aggregateStats(this.props.data, {});
    return Object.keys(data)
      .filter(key => key)
      .sort()
      .map(country => ({ count: data[country].count, country: countryCodesMap[country] }));
  };
}

export default StatsCountryTable;
